import { type PropsWithChildren, useEffect, useState } from "react";
import { Provider } from "react-redux";
import type { SmartNumber } from "@/features/sub-families/types";
import { makerStore } from "@/redux/store.ts";
import type { Nullable } from "@/types";
import { smartNumberSetSubFamilyAction } from "../slices/smart-number-slice.ts";

type Props = PropsWithChildren<{ smartNumber: Nullable<SmartNumber> }>;
export default function StoreProvider({ children, smartNumber }: Props) {
    const [store] = useState(() => makerStore());

    useEffect(() => {
        store.dispatch(smartNumberSetSubFamilyAction(smartNumber));
    }, [smartNumber, store]);

    return <Provider store={store}>{children}</Provider>;
}
